import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CategoriesComponent } from './categories/categories.component';
import { IonicModule } from '@ionic/angular';
import { GeneralesComponentsModule } from 'src/app/generales-components/generales-components.module';
import { CardCategorieComponent } from 'src/app/components/card-categorie/card-categorie.component';
import { PipeModule } from 'src/app/pipes/pipe-module.module';
import { RecetasPaginadasComponent } from './recetas-paginadas/recetas-paginadas.component';
import { GalleryComponentsModule } from 'src/app/gallery-components/gallery-components.module';
import { ContactBtnComponent } from './contact-btn/contact-btn.component';
import { TranslateModule } from '@ngx-translate/core';
import { DirectivesModule } from 'src/app/directives/directives.module';

const declarations = [
  CategoriesComponent,
  CardCategorieComponent,
  RecetasPaginadasComponent,
  ContactBtnComponent,
];

@NgModule({
  declarations,
  imports: [
    CommonModule,
    IonicModule,
    GeneralesComponentsModule,
    PipeModule,
    GalleryComponentsModule,
    TranslateModule,
    DirectivesModule,
  ],
  exports: declarations,
})
export class RecetasComponentsModule {}
